// <s-cart-attribute>: saves a gift message (cart attribute) or order note on change
// through the Ajax cart API so the value survives cart partial refreshes.

class CartAttribute extends HTMLElement {
  #field = null;
  #controller = null;

  connectedCallback() {
    this.#field = this.querySelector('textarea, input');
    this.#field?.addEventListener('change', this.#save);
  }

  disconnectedCallback() {
    this.#field?.removeEventListener('change', this.#save);
    this.#controller?.abort();
  }

  #save = async () => {
    if (!this.#field) return;
    const value = this.#field.value.trim();
    const body = this.hasAttribute('data-note')
      ? { note: value }
      : { attributes: { [this.dataset.attribute || 'Gift message']: value } };

    this.#controller?.abort();
    this.#controller = new AbortController();
    const root = window.Shopify?.routes?.root || '/';
    this.setAttribute('aria-busy', 'true');
    try {
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
        signal: this.#controller.signal,
      });
    } catch (error) {
      // Leave the typed value in place; it is resubmitted on the next change.
    } finally {
      this.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('s-cart-attribute')) customElements.define('s-cart-attribute', CartAttribute);
